import { render, staticRenderFns } from "./IconBlank.vue?vue&type=template&id=ed0fb318&"
import script from "./IconBlank.vue?vue&type=script&lang=ts&"
export * from "./IconBlank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports